import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Header from "../../components/layout/Header";
import Hero from "../../components/About/hero/Hero";
import Footer from "../../components/layout/Footer";
import { GuideBottom } from "../../components/Home/Guide/Guide";
import { SERVICES } from "../../data/services";
import { formatPrice, ADD_ON_SERVICES } from "../../data/pricing";
import { Animate, Stagger } from "../../components/animations";

function ServicesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero heading="Our Services" />
      <section className="layout-section">
        <div className="layout-container">
          <Animate variant="fadeUp">
            <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
              Comprehensive study-abroad services designed to support you at every
              stage of your journey — from application to arrival.
            </p>
          </Animate>
          <Stagger
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
            variant="fadeUp"
            stagger={100}
          >
            {SERVICES.map((service) => {
              const addon = ADD_ON_SERVICES.find((a) => a.route === service.route);
              return (
                <div
                  key={service.id}
                  className="border rounded-xl overflow-hidden hover:shadow-lg transition-shadow anim-hover-lift bg-white"
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6">
                    <h2 id="heading-md">
                      {service.icon} {service.title}
                    </h2>
                    <p className="text-gray-600 mt-2">{service.description}</p>
                    {addon && (
                      <p className="text-blue-600 font-semibold mt-3">
                        From {formatPrice(addon.price)}
                      </p>
                    )}
                    <div className="flex gap-3 mt-4">
                      <NavLink
                        to={service.route}
                        className="text-blue-600 font-medium hover:underline"
                      >
                        Learn More →
                      </NavLink>
                    </div>
                  </div>
                </div>
              );
            })}
          </Stagger>
        </div>
      </section>
      <Animate variant="fadeUp">
        <GuideBottom />
      </Animate>
      <Footer />
    </>
  );
}

export default ServicesPage;
